import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { Card } from "react-bootstrap";
import { useLogout, DefaultRoutes, useGetLocalAccountListQuery, AppConfiguration, PublicRoutes, QueryParamKeys, QueryParamValues } from "src/common";
import { Icon } from "src/components";
import DeviceDeletedImage from "src/assets/images/device-deleted.svg";

const is_app = AppConfiguration.buildForApp();
// Description: Displays a notification when the current device has been removed by an administrator.
//              In app mode with multiple local accounts, offers a link to switch to another account.
function DeviceDeletedComponent() {
  const { data } = useGetLocalAccountListQuery(undefined, { skip: !is_app });
  const { handleStateLogout } = useLogout();
  const show_switch = is_app && (data?.users?.length ?? 0) > 1;

  useEffect(() => {
    handleStateLogout();
  }, []);

  return (
    <div className="mx-auto max-600 mt-4">
      <h1 className="main-header">This Device was removed.</h1>
      <Card className="pv-card mb-2 border-0">
        <Card.Img variant="top" className="py-3" src={DeviceDeletedImage} />
        <Card.Body>
          <p className="semi-bold fs-3 mb-4">The device has been removed from PreVeil by your administrator.</p>
          <p>Please contact your organization's administrator for more information.</p>
          {show_switch && <p>If you have multiple accounts, <Link to={`/${PublicRoutes.choose_account_route}?${QueryParamKeys.PAGE_ACTION_QUERY_KEY}=${QueryParamValues.switch}`}>click here to switch to another account</Link>.</p>}
        </Card.Body>
      </Card>
      <p><Icon className="pv-icon-question" /><span>Learn more about locked devices <a target="_blank" rel="noreferrer" href={`${DefaultRoutes.remote_webapp_url}/support`}>preveil.com/support</a></span></p>
    </div>
  );
}

export default React.memo(DeviceDeletedComponent);